import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Section = styled.section`
  padding: 6rem 8%;
`;

export const Header = styled.div`
  text-align: center;
`;

export const SectionTag = styled.span`
  display: inline-block;
  color: ${theme.colors.orange};
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`;

export const SectionTitle = styled.h2`
  font-family: ${theme.fonts.display};
  font-size: clamp(2rem, 3.5vw, 2.9rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: ${theme.colors.black};
  margin-bottom: 1rem;
`;

export const SectionSub = styled.p`
  color: ${theme.colors.mid};
  font-size: 1rem;
  line-height: 1.7;
  max-width: 540px;
  font-weight: 400;
  margin-left: auto;
  margin-right: auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3.5rem;
  position: relative;

  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Connector = styled.div`
  position: absolute;
  top: 24px;
  left: calc(16.67% + 24px);
  right: calc(16.67% + 24px);
  height: 2px;
  background: linear-gradient(
    90deg,
    ${theme.colors.orange},
    rgba(253, 131, 96, 0.15)
  );

  @media (max-width: 960px) {
    display: none;
  }
`;

export const Step = styled.div`
  text-align: center;
  position: relative;
`;

export const StepCircle = styled.div`
  width: 48px;
  height: 48px;
  background: ${theme.colors.orange};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${theme.fonts.display};
  font-weight: 800;
  font-size: 1.1rem;
  color: white;
  margin: 0 auto 1.4rem;
  box-shadow: 0 4px 16px rgba(253, 131, 96, 0.4);
`;

export const StepTitle = styled.h3`
  font-family: ${theme.fonts.display};
  font-weight: 700;
  font-size: 1rem;
  color: ${theme.colors.black};
  margin-bottom: 0.6rem;
`;

export const StepText = styled.p`
  color: ${theme.colors.mid};
  font-size: 0.88rem;
  line-height: 1.65;
`;
